import React from 'react';
import { IoMdClose } from 'react-icons/io';
import successIcon from '../assets/success.svg';

const SuccessModal = ({ setShowModal, resetFields, claimMode }) => {
  return (
    <div>
      <div
        onClick={() => setShowModal(false)}
        className="cursor-pointer h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[110] outline-none focus:outline-none scrollbar-hide"
      >
        <div id='modal' className="relative my-6 mx-[2%] sm:mx-0">
          {/*content*/}
          <div className="cursor-default fixed relative rounded-t-[30px] rounded-[30px] border-0 shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className='w-[327px] md:w-[500px] pt-[27px] pb-[56px] px-[42px] md:px-[32px] flex flex-col gap-[7px]'>
              <div className='w-full flex items-end justify-end'>
                <IoMdClose onClick={() => setShowModal(false)} className='cursor-pointer w-[25px] h-[25px]' />
              </div>
              <div className='w-full flex flex-col gap-[13px] items-center justify-center'>
              <div className='mt-[6px] flex bg-[#4FBF26D9] p-[2.5] rounded-full items-center justify-center w-[35px] h-[35px]'>
                  <img src={successIcon} alt="Success Icon" className='' />
                </div>
                <div className='w-full flex flex-col gap-[9px] md:gap-[6px] items-center justify-center text-center'>
                  <h2 className='font-black text-[16px] leading-[21.6px] md:text-[24px] md:leading-[32.4px]'>Success!</h2>
                  <p className='font-medium text-[14px] text-ravash leading-[18.9px]'>
                    {claimMode ? (
                      <>
                        Thank you for claiming this business! Our team will review the details within
                        <strong> 2 to 3 business days</strong>. Once the claim is verified, you’ll receive
                        an email notification confirming your ownership.
                      </>
                    ) : (
                      <>
                        Thank you for submitting a vendor! Our team will review the details within
                        <strong> 2 to 3 business days</strong>. If the submission is approved,
                      we will send you an email notification so you can check the status.
                      </>
                    )}
                  </p>
                </div>
                <div className='mt-[10px] w-full flex flex-col md:flex-row gap-[13px] items-center justify-center '>
                  <button
                    onClick={() => {
                      resetFields();
                      setShowModal(false); // Close modal
                    }}
                    className='w-full h-[50px]  rounded-[80px] bg-ravblue flex items-center text-center justify-center font-bold text-[16px] text-white leading-[21.6px]'
                  >
                    Submit Another Vendor
                  </button>
                  <button
                    onClick={() => {
                      setShowModal(false);
                      window.location.href = "/"; // Redirect to home page
                    }}
                    className='w-full h-[50px] rounded-[80px] bg-white border-solid border-[1px] border-[#AAAAAA] flex items-center text-center justify-center font-bold text-[16px] text-[#707070] leading-[21.6px]'
                  >
                    Go to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-[100] bg-black opacity-60 xm:opacity-70 overflow-hidden"></div>
    </div>
  );
};

export default SuccessModal;